import { useMemo } from 'react';
import { FormattedMessage } from 'react-intl';

import { Typography } from '@mui/material';

import { Offering } from '@arrived/models';
import { useOfferingDocumentsQuery } from '@arrived/queries';

import { PROPERTY_HASH_MAP } from '../Property.constants';
import { PropertyDetailsOfferingTerms } from './OfferingTerms';
import { PropertyDetailsList } from './PropertyDetailsList';
import { PropertyDetailsSection } from './PropertyDetailsSection';

import { documentsConfig } from './config/documentsConfig';
import { filterPropertyFinancialDocuments } from './utils/filterPropertyFinancialDocuments';

export const PropertyDetailsOfferingDetails = ({ offering }: { offering: Offering }) => {
  const offeringDocumentsState = useOfferingDocumentsQuery(offering.id);
  const documents = useMemo(() => {
    if (offeringDocumentsState.isSuccess) {
      return filterPropertyFinancialDocuments(offeringDocumentsState.data, false);
    }
    return;
  }, [offeringDocumentsState]);

  if (offering.isFund) return null;

  return (
    <PropertyDetailsSection
      hash={PROPERTY_HASH_MAP.offeringDetails}
      areSectionsColumns={true}
      title={<FormattedMessage id="property-details-offering-details-title" defaultMessage="Offering Details" />}
      description={
        <FormattedMessage
          id="property-details-offering-details-description"
          defaultMessage="The Offering Details provide a breakdown of the financials for a specific property offering. The Offering Details show the operating plan for the property, including how the Raise Amount proceeds will be used. For transparency, we also like to share a breakdown of the Arrived fees. And if you're interested in more information, we also link to other resource documents that go into more depth around each offering."
        />
      }
    >
      <PropertyDetailsOfferingTerms offering={offering} />
      {documents && documents.length > 0 && (
        <PropertyDetailsList listData={documentsConfig(documents)}>
          <Typography variant="h5.semibold">
            <FormattedMessage id="property-details-offering-documents-title" defaultMessage="Documents" />
          </Typography>
        </PropertyDetailsList>
      )}
    </PropertyDetailsSection>
  );
};
